<template>
  <div>
    <!-- 25.6.6 共用底部 dxm -->
    <div class="footer" :class="{ 'footer-ip': type == 'home' }">
      <div class="footer_main container">
        <div class="footer_main_left">
          <div class="left_logo">
            <!-- <img :src="footerData.shop_buttom_logo" /> -->
            <img src="../assets/imgs/logo_b.png" />
          </div>
          <div class="left-text">
            {{
              langSet == "cn"
                ? footerData.bottom_addr
                : footerData.bottom_addr_en
            }}<br />{{ langSet == "cn" ? "邮箱" : "Email" }}:{{
              langSet == "cn"
                ? footerData.bottom_zipcode
                : footerData.bottom_zipcode_en
            }}<br />{{ langSet == "cn" ? "电话" : "Tel" }}:{{
              footerData.bottom_tel
            }}
          </div>
        </div>
        <div class="footer_main_middle">
          <ul v-if="langSet == 'cn'">
            <li>
              <img :src="footerData.gongzhonghao" />
              <div>{{ langSet == "cn" ? "公众号" : "Official Account" }}</div>
            </li>
            <li>
              <img :src="footerData.line" />
              <div>Linkedln</div>
            </li>
            <li>
              <img :src="footerData.facebook" />
              <div>Facebook</div>
            </li>
            <li>
              <img :src="footerData.instagram" />
              <div>Instagram</div>
            </li>
          </ul>
          <template v-else>
            <div class="footer_us">Connect with us</div>
            <div class="footer_icon flex flex_content_center">
              <a
                href="https://www.facebook.com/TheChinaDentalShow?mibextid=LQQJ4d"
                target="_blank"
              >
                <img src="../assets/fc.png" alt="" />
              </a>
              <a
                href="https://instagram.com/thechinadentalshow"
                target="_blank"
              >
                <img src="../assets/ig.png" alt="" />
              </a>
              <a
                href="javascript:;"
                @mouseenter="showTooltip = true"
                @mouseleave="showTooltip = false"
              >
                <img src="../assets/wx.png" alt="" />
                <transition name="fade">
                  <div v-if="showTooltip" class="tooltip">
                    <img src="../assets/enewm.jpg" height="100px" />
                  </div>
                </transition>
              </a>
              <a
                href="https://www.linkedin.com/company/china-dental-show/"
                target="_blank"
              >
                <img src="../assets/in.png" alt="" />
              </a>
            </div>
          </template>
        </div>
        <div class="footer_main_right flex">
          <div
            class="footer_list"
            v-for="(item, index) in nav"
            :key="index"
            :class="langSet == 'cn' ? '' : 'footer_list_en'"
          >
            <div class="right_title">
              {{ langSet == "cn" ? item.name_cn : item.name_en }}
            </div>
            <div class="right_list">
              <p
                class="flex flex_items_center fb"
                v-for="(_item, _index) in item.children"
                :key="_index"
                @click="toLink(_item)"
              >
                {{ langSet == "cn" ? _item.name_cn : _item.name_en
                }}<img :src="require('../assets/imgs/icon_right.png')" alt="" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="footer-copyright" v-if="copyRight.length > 0">
        公安备案号：{{ copyRight[1].key }}&nbsp;&nbsp;&nbsp;<a
          :href="copyRight[0].value"
          >ICP备案号：{{ copyRight[0].key }}</a
        >
      </div> -->
      <div class="footer-copyright" v-if="copyRight.length > 0">
        <div v-for="(v, i) in copyRight" :key="i">
          <span
            class="footer-copyright-label"
            @click="handleClickCopyright(v)"
            >{{ v.key }}</span
          >
          <span>|</span>
        </div>
        Copyright © 2010-{{ new Date().getFullYear() }}
        {{
          langSet == "cn"
            ? "国药励展展览有限责任公司 版权所有"
            : "Reed Sinopharm Exhibitions Co., Ltd. All Rights Reserved."
        }}
      </div>
    </div>
    <!-- 25.6.9 侧边栏 dxm -->
    <div class="side_wrap">
      <div
        class="side_item flex flex_items_center flex_content_sb"
        @click="
          toLink(
            langSet == 'cn'
              ? footerData.free_visit_url
              : footerData.free_visit_url_en
          )
        "
      >
        <img :src="require('../assets/imgs/icon_img3.png')" alt="" />
        <div class="side_text" style="padding-right: 20px">
          {{ langSet == "cn" ? "免费参观" : "Visitor Registration" }}
        </div>
      </div>
      <!--      2025年8月18日15:21:01 隐藏 秀鸽-->
      <!--      25.10.17 根据文档，显示 dxm-->
      <div
        class="side_item flex flex_items_center flex_content_sb"
        @click="
          toLink(
            langSet == 'cn'
              ? footerData.exhibition_predict
              : footerData.exhibition_predict_en
          )
        "
      >
        <div class="side_text" style="padding-left: 20px">
          {{ langSet == "cn" ? "展位预定" : "Book a Stand" }}
        </div>
        <img :src="require('../assets/imgs/icon_img4.png')" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { webMenu, getWebsiteBase, getCopyright } from "@/api/api";

export default {
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      langSet: "",
      nav: [],
      screenWidth: 0,
      footerData: {},
      copyRight: [],
      showTooltip: false,
      metaData: {},
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
    this.getMenu();
    //25.6.9 获取网站基本信息 dxm
    this.getWebsite();
    //25.6.9 获取备案信息 dxm
    this.getCopyrightData();
  },
  methods: {
    // 获取屏幕宽度和高度的函数
    getScreenSize() {
      return {
        width: window.innerWidth,
      };
    },
    getMenu() {
      let arr = [];
      let data = {
        page_type: 0,
      };
      webMenu(data)
        .then((res) => {
          if (res.code == 1) {
            let lists = res.data.lists;
            lists.map((item, index) => {
              if (item.is_bottom == "是") {
                arr.push(item);
              }
            });
            this.nav = arr;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWebsite() {
      getWebsiteBase()
        .then((res) => {
          if (res.code == 1) {
            this.footerData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCopyrightData() {
      getCopyright()
        .then((res) => {
          if (res.code == 1) {
            this.copyRight = res.data;
            console.log(this.copyRight, "copyright");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //跳转页面
    toLink(item) {
      if (item.http_url_cn || item.http_url_en) {
        if (item.type == "内部跳转") {
          this.$router.push({
            path: this.langSet == "cn" ? item.http_url_cn : item.http_url_en,
          });
        } else {
          let path = this.langSet == "cn" ? item.http_url_cn : item.http_url_en;
          window.open(path, "_blank");
        }
      } else {
        window.open(item, "_blank");
      }
    },
    handleClickCopyright(flag) {
      if (flag.value) {
        window.open(flag.value, "_blank");
      }
    },
  },
};
</script>

<style lang="scss">
.record a {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}
.record a:nth-child(1) {
  margin-right: 5px;
}
.footer {
  width: 100%;
  min-height: 680px;
  color: #fff;
  font-size: 18px;
  padding-top: 320px;
  background: url("../assets/imgs/footer_bg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  margin-top: -280px;
  position: relative;
  .container {
    padding-bottom: 38px;
    border-bottom: 1px solid #777aa3;
  }
  .footer_main {
    display: flex;
    position: relative;
    justify-content: space-between;
    .footer_main_left {
      width: 340px;
      height: auto;
      margin-right: 24px;
      overflow: hidden;
      .left_logo {
        width: 247px;
        height: 145px;
        overflow: hidden;
        img {
          width: 100%;
          object-fit: contain;
          height: 100%;
        }
      }
      .left-text {
        width: 100%;
        height: auto;
        line-height: 24px;
        margin-top: 12px;
        font-size: 14px;
        color: #fff;
        overflow: hidden;
      }
    }
    .footer_main_middle {
      flex: 1;
      height: auto;
      overflow: hidden;
      margin-top: 30px;
      margin-right: 2%;
      ul {
        display: flex;
        li {
          width: 108px;
          font-size: 16px;
          line-height: 22px;
          text-align: center;
          margin-right: 40px;
          img {
            width: 100%;
            height: 108px;
            background: #fff;
            display: block;
            margin-bottom: 2px;
          }
        }
      }
      .footer_us {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        line-height: 64px;
      }
      .footer_icon {
        width: 70%;
        padding: 60px 0;
        border-radius: 7px;
        margin: 0 auto;
        background: rgba(255, 255, 255, 0.32);
        a {
          padding: 0 10px;
          position: relative;
          .tooltip {
            position: absolute;
            bottom: 0;
            right: -110px;
            z-index: 9;
            img {
              width: 150px;
              height: 150px;
            }
          }
        }
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
    .footer_main_right {
      width: 262px;
      height: auto;
      display: flex;
      overflow: hidden;
      .footer_list {
        height: auto;
        &:first-child {
          margin-right: 80px;
        }
        .right_title {
          width: 100%;
          height: 38px;
          line-height: 38px;
          font-size: 24px;
          color: #fff;
          font-weight: bold;
        }
        .right_list {
          width: 100%;
          height: auto;
          overflow: hidden;
          margin-top: 20px;
          cursor: pointer;
          p {
            width: 100%;
            line-height: 25px;
            margin-top: 20px;
            font-size: 18px;
            color: #fff;
            img {
              width: 13px;
              height: 13px;
            }
          }
        }
      }
      .footer_list_en {
        &:first-child {
          margin-right: 40px;
        }
      }
    }
  }
  .fmright {
    margin-right: 29px;
  }
  .footer-copyright {
    height: 71px;
    line-height: 71px;
    font-size: 14px;
    color: #d1dae1;
    display: flex;
    justify-content: center;
    span {
      margin-right: 8px;
    }
    .footer-copyright-label {
      cursor: pointer;
    }
  }
}
.footer-ip {
  padding-top: 20%;
  min-height: auto;
  margin-top: 0;
  background: url("../assets/imgs/footer_bg_ip.png") no-repeat;
  background-size: cover;
}
.side_wrap {
  position: fixed;
  top: 55%;
  right: 0;
  z-index: 9999;
  .side_item {
    width: 208px;
    height: 52px;
    font-weight: 500;
    font-size: 20px;
    color: #004190;
    cursor: pointer;
    padding: 0 5px;
    box-sizing: border-box;
    background: #e9f4ff;
    border-radius: 28px;
    margin-bottom: 19px;
    .side_text {
      flex: 1;
      text-align: center;
    }
    img {
      height: 52px;
    }
  }
}

@media only screen and (max-width: 1280px) {
  .footer .footer-copyright {
    height: auto;
    flex-wrap: wrap;
    line-height: 30px;
    padding: 20px 0;
  }
  .footer .footer_main .footer_main_right {
    display: none;
  }
  .footer .footer_main .footer_main_middle {
    margin-right: 0;
    ul {
      justify-content: flex-end;
      li {
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .footer-ip{
    padding-top: 280px;
    background-position: bottom center;
    .footer_main{
      padding-bottom: 20px;
    }
    .footer-copyright{
      line-height: 20px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .side_wrap {
    display: none;
  }
  .footer {
    height: auto;
    min-height: auto;
    padding-top: 1.96rem;
    background: url("../assets/imgs/footer_bgm.png") no-repeat;
    background-size: 100% 100%;
    .container {
      padding-bottom: 0.48rem;
    }
    .footer_main {
      flex-wrap: wrap;
      .footer_main_left {
        display: flex;
        align-items: center;
        width: 100%;
        margin-right: 0;
        .left_logo {
          width: 3.28rem;
          height: 1.96rem;
          margin-right: 0.17rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .left-text {
          flex: 1;
          margin-top: 0;
        }
      }
      .footer_main_middle {
        width: 100%;
        flex: inherit;
        margin-top: 0.48rem;
        ul li {
          width: 1.5rem;
          font-size: 0.27rem;
          img {
            width: 100%;
            height: 1.5rem;
            margin-right: 0.25rem;
          }
        }
        .footer_us,
        .footer_icon {
          display: none;
        }
      }
    }
  }
  .footer .footer-copyright {
    height: 1.25rem;
    padding: 0 0.5rem;
    font-size: 0.14rem;
    color: #ffffff;
    line-height: 0.33rem;
    display: flex;
    align-items: center;
    span {
      margin-right: 0.15rem;
    }
  }
  .footer-ip{
    margin-top: -100px;
    background: url("../assets/imgs/footer_bgm_ip.png") no-repeat;
    background-size: cover;
  }
}
</style>